// extracted by mini-css-extract-plugin
module.exports = {"OnlineStoreRightsA3":"OnlineStoreRightsA4_OnlineStoreRightsA3__eHvdn"};